import BasePeripheral from '@appblocks/codegeneration/Peripherals/_BasePeripheral';

import PlatformUtils from '@appblocks/platforms/PlatformUtils';
import { SettingType, Setting, BlockType } from '@appblocks/codegeneration/types';

export default class IOPort extends BasePeripheral {
    constructor() {
        super();
        this.id = 'ioport';
        this.name = 'IO Port';
        this.requirements = ['board', 'tios'];
        const settings: Array<Setting> = [
            {
                id: 'PORT',
                name: 'Port',
                settingType: SettingType.HIDDEN,
                required: true,
                default: '0',
            },
            {
                id: 'P0',
                name: 'Pin0',
                settingType: SettingType.PIN,
                meta: 'P',
                required: true,
                default: '',
            },
            {
                id: 'P1',
                name: 'Pin1',
                settingType: SettingType.PIN,
                meta: 'P',
                required: true,
                default: '',
            },
            {
                id: 'P2',
                name: 'Pin2',
                settingType: SettingType.PIN,
                meta: 'P',
                required: true,
                default: '',
            },
            {
                id: 'P3',
                name: 'Pin3',
                settingType: SettingType.PIN,
                meta: 'P',
                required: true,
                default: '',
            },
            {
                id: 'P4',
                name: 'Pin4',
                settingType: SettingType.PIN,
                meta: 'P',
                required: true,
                default: '',
            },
            {
                id: 'P5',
                name: 'Pin5',
                settingType: SettingType.PIN,
                meta: 'P',
                required: true,
                default: '',
            },
            {
                id: 'P6',
                name: 'Pin6',
                settingType: SettingType.PIN,
                meta: 'P',
                required: true,
                default: '',
            },
            {
                id: 'P7',
                name: 'Pin7',
                settingType: SettingType.PIN,
                meta: 'P',
                required: true,
                default: '',
            },
            {
                id: 'direction',
                name: 'Direction',
                settingType: SettingType.OPTION,
                required: true,
                default: '&b00000000',
                options: [
                    {
                        name: 'input',
                        value: '&b00000000',
                    },
                    {
                        name: 'output',
                        value: '&b11111111',
                    },
                ],
            },
            {
                id: 'state',
                name: 'Initial State',
                settingType: SettingType.OPTION,
                required: true,
                default: '&b00000000',
                options: [
                    {
                        name: 'high',
                        value: '&b11111111',
                    },
                    {
                        name: 'low',
                        value: '&b00000000',
                    },
                ],
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getCodeBlocks() {
        const blocks = [];
        blocks.push({
            location: 'boot',
            blockType: BlockType.CODE,
            template: `
    'io port setup for port ${(this.getSettingValue('PORT'))}
    io.portnum=${this.getSettingValue('NAME')}_PORT
    io.portenabled=${this.getSettingValue('direction')}
    io.portstate=${this.getSettingValue('state')}`,
        });

        blocks.push({
            location: 'GLOBAL_CONSTS',
            blockType: BlockType.CODE,
            template: `
const ${this.getSettingValue('NAME')}_PORT=${PlatformUtils.getEnum(this.getSettingValue('PORT'), 'pl_io_port_num', this.project.device.platform)}`,
        });
        return blocks;
    }

    getDetails(): string {
        return 'https://docs.tibbo.com/taiko/io_lines_method_1';
    }
}
